import gsap from 'gsap'
import tailwindConfig from "../../tailwind.config";

let lgScreen = tailwindConfig.theme.screens.lg.replace( 'px', '' );

export default function(){
	/* Search */
	const searchIcon = document.querySelector( '[data-name="search-icon"]' );
	const searchForm = document.querySelector( '[data-name="search-form"]' );
	
	let isMobileMenu = false;
	if ( document.querySelector( 'body' ).classList.contains( 'mobile-menu' ) ) {
		isMobileMenu = true;
	}

	if ( searchIcon && searchForm && ! isMobileMenu ){
		searchIcon.addEventListener( 'click', function(){
			if ( searchForm.clientWidth === 0 ) {
				gsap.to( searchForm, { width: 'auto', opacity: 1,  duration: 0.3 } )
			} else {
				gsap.to( searchForm, { width: 0, opacity: 0,  duration: 0.3 } )
			}
		})
	}




	/* MOBILE MENU */	
	if ( window.innerWidth < lgScreen ){
		document.querySelector('body').classList.add('mobile-menu' )
		document.querySelector( '.hamburger' ).classList.remove('hidden')
		document.querySelector( '.hamburger' ).classList.remove('pointer-events-none')
		document.querySelector( '.menus-wrapper' ).classList.remove('hidden')

		// wrap menu button in a div
		let menuButton = document.querySelector( '#main-menu .button' )
		menuButton?.classList.remove('button--teal')
		menuButton?.classList.remove('button')
	}

	function hamburgerOpenAnimation(){		
		const hamburger = document.querySelector('[data-name="hamburger"]');

		if ( hamburger ){
			gsap.to( hamburger.querySelector( 'div:nth-child(2)' ), { autoAlpha: 0, duration: 0.2  } )
			gsap.to( hamburger.querySelector( 'div:nth-child(1)' ), { y: 10, rotate: 45, duration: 0.3 } )
			gsap.to( hamburger.querySelector( 'div:nth-child(3)' ), { y: -5, rotate: -45, duration: 0.3 } )
		}
	}
	function hamburgerCloseAnimation(){
		const hamburger = document.querySelector('[data-name="hamburger"]');

		if ( hamburger ){
			gsap.to( hamburger.querySelector( 'div:nth-child(2)' ), { autoAlpha: 1, duration: 0.2  } )
			gsap.to( hamburger.querySelector( 'div:nth-child(1)' ), { y: 0, rotate: 0, duration: 0.3 } )
			gsap.to( hamburger.querySelector( 'div:nth-child(3)' ), { y: 0, rotate: 0, duration: 0.3 } )
		}
	}

	let logoChanged = false;
	function changeReplaceLogo( beforeOpen = true ){
		let logoFill = document.querySelector('.logo svg path').getAttribute('fill')

		if ( beforeOpen && logoFill === '#ffffff' ) {
			document.querySelectorAll('.top-nav .logo svg path').forEach(function(element) {
				element.setAttribute('fill', '#064891');
			});
			
			logoChanged = true;
		} else if ( ! beforeOpen && logoChanged ) {
			document.querySelectorAll('.top-nav .logo svg path').forEach(function(element) {
				element.setAttribute('fill', '#ffffff');
			});
			
			logoChanged = false;
		} else {
			logoChanged = false;
		}
	}

	// Open menu
	const hamburger    = document.querySelector('[data-name="hamburger"]');
	const menusWrapper = document.querySelector('.menus-wrapper');

	if ( hamburger && menusWrapper ) {
		hamburger.addEventListener('click', () => {		

			document.querySelector('.mobile-menu')?.classList.toggle('open')
			menusWrapper.classList.toggle('open')

			if ( menusWrapper.classList.contains('open') ){
				document.querySelector( 'body' ).classList.add('scroll-lock' )
				changeReplaceLogo(true)
				hamburgerOpenAnimation()
				gsap.to( menusWrapper, { left: 0, duration: 0.4 } )

				// Stagger animation for the links
				const mainMenuItems = menusWrapper.querySelectorAll('#main-menu > li');
				const topMenu       = menusWrapper.querySelectorAll('#secondary-menu > li');

				gsap.fromTo( mainMenuItems,
					{ autoAlpha: 0, x: 100 }, { autoAlpha: 1, x: 0, duration: 0.5, stagger: 0.05,
						onComplete: function () {
							gsap.set(this.targets(), { clearProps: "all" });
						}
					}
				)
				gsap.fromTo( topMenu, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, stagger: 0.05, delay: 1 } )
			} else {
				document.querySelector( 'body' ).classList.remove('scroll-lock' )
				changeReplaceLogo( false )
				hamburgerCloseAnimation()
				gsap.to( menusWrapper, { left: '100vw', duration: 0.4 } )
			}
		})
	}
}